const IcoNames = {
	'Line Icons': [
		'fe_activity',
		'fe_airplay',
		'fe_alertCircle',
		'fe_alertOctagon',
		'fe_alertTriangle',
		'fe_alignCenter',
		'fe_alignJustify',
		'fe_alignLeft',
		'fe_alignRight',
		'fe_anchor',
		'fe_aperture',
		'fe_archive',
		'fe_arrowDown',
		'fe_arrowDownCircle',
		'fe_arrowDownLeft',
		'fe_arrowDownRight',
		'fe_arrowLeft',
		'fe_arrowLeftCircle',
		'fe_arrowRight',
		'fe_arrowRightCircle',
		'fe_arrowUp',
		'fe_arrowUpCircle',
		'fe_arrowUpLeft',
		'fe_arrowUpRight',
		'fe_atSign',
		'fe_award',
		'fe_barChart',
		'fe_barChart2',
		'fe_battery',
		'fe_batteryCharging',
		'fe_bell',
		'fe_bellOff',
		'fe_bluetooth',
		'fe_bold',
		'fe_book',
		'fe_bookOpen',
		'fe_bookmark',
		'fe_box',
		'fe_briefcase',
		'fe_calendar',
		'fe_camera',
		'fe_cameraOff',
		'fe_cast',
		'fe_check',
		'fe_checkCircle',
		'fe_checkSquare',
		'fe_chevronDown',
		'fe_chevronLeft',
		'fe_chevronRight',
		'fe_chevronUp',
		'fe_chevronsDown',
		'fe_chevronsLeft',
		'fe_chevronsRight',
		'fe_chevronsUp',
		'fe_chrome',
		'fe_circle',
		'fe_clipboard',
		'fe_clock',
		'fe_cloud',
		'fe_cloudDrizzle',
		'fe_cloudLightning',
		'fe_cloudOff',
		'fe_cloudRain',
		'fe_cloudSnow',
		'fe_code',
		'fe_codepen',
		'fe_command',
		'fe_compass',
		'fe_copy',
		'fe_cornerDownLeft',
		'fe_cornerDownRight',
		'fe_cornerLeftDown',
		'fe_cornerLeftUp',
		'fe_cornerRightDown',
		'fe_cornerRightUp',
		'fe_cornerUpLeft',
		'fe_cornerUpRight',
		'fe_cpu',
		'fe_creditCard',
		'fe_crop',
		'fe_crosshair',
		'fe_database',
		'fe_deleteIconic',
		'fe_disc',
		'fe_dollarSign',
		'fe_download',
		'fe_downloadCloud',
		'fe_droplet',
		'fe_edit',
		'fe_edit2',
		'fe_edit3',
		'fe_externalLink',
		'fe_eye',
		'fe_eyeOff',
		'fe_facebook',
		'fe_fastForward',
		'fe_feather',
		'fe_file',
		'fe_fileMinus',
		'fe_filePlus',
		'fe_fileText',
		'fe_film',
		'fe_filter',
		'fe_flag',
		'fe_folder',
		'fe_folderMinus',
		'fe_folderPlus',
		'fe_gift',
		'fe_gitBranch',
		'fe_gitCommit',
		'fe_gitMerge',
		'fe_gitPullRequest',
		'fe_github',
		'fe_gitlab',
		'fe_globe',
		'fe_grid',
		'fe_hardDrive',
		'fe_hash',
		'fe_headphones',
		'fe_heart',
		'fe_helpCircle',
		'fe_home',
		'fe_image',
		'fe_inbox',
		'fe_info',
		'fe_instagram',
		'fe_italic',
		'fe_layers',
		'fe_layout',
		'fe_lifeBuoy',
		'fe_link',
		'fe_link2',
		'fe_linkedin',
		'fe_list',
		'fe_loader',
		'fe_lock',
		'fe_logIn',
		'fe_logOut',
		'fe_mail',
		'fe_map',
		'fe_mapPin',
		'fe_maximize',
		'fe_maximize2',
		'fe_menu',
		'fe_messageCircle',
		'fe_messageSquare',
		'fe_mic',
		'fe_micOff',
		'fe_minimize',
		'fe_minimize2',
		'fe_minus',
		'fe_minusCircle',
		'fe_minusSquare',
		'fe_monitor',
		'fe_moon',
		'fe_moreHorizontal',
		'fe_moreVertical',
		'fe_move',
		'fe_music',
		'fe_navigation',
		'fe_navigation2',
		'fe_octagon',
		'fe_packageIcon',
		'fe_paperclip',
		'fe_pause',
		'fe_pauseCircle',
		'fe_percent',
		'fe_phone',
		'fe_phoneCall',
		'fe_phoneForwarded',
		'fe_phoneIncoming',
		'fe_phoneMissed',
		'fe_phoneOff',
		'fe_phoneOutgoing',
		'fe_pieChart',
		'fe_play',
		'fe_playCircle',
		'fe_plus',
		'fe_plusCircle',
		'fe_plusSquare',
		'fe_pocket',
		'fe_power',
		'fe_printer',
		'fe_radio',
		'fe_refreshCcw',
		'fe_refreshCw',
		'fe_repeat',
		'fe_rewind',
		'fe_rotateCcw',
		'fe_rotateCw',
		'fe_rss',
		'fe_save',
		'fe_scissors',
		'fe_search',
		'fe_send',
		'fe_server',
		'fe_settings',
		'fe_share',
		'fe_share2',
		'fe_shield',
		'fe_shieldOff',
		'fe_shoppingBag',
		'fe_shoppingCart',
		'fe_shuffle',
		'fe_sidebar',
		'fe_skipBack',
		'fe_skipForward',
		'fe_slack',
		'fe_slash',
		'fe_sliders',
		'fe_smartphone',
		'fe_speaker',
		'fe_square',
		'fe_star',
		'fe_stopCircle',
		'fe_sun',
		'fe_sunrise',
		'fe_sunset',
		'fe_tablet',
		'fe_tag',
		'fe_target',
		'fe_terminal',
		'fe_thermometer',
		'fe_thumbsDown',
		'fe_thumbsUp',
		'fe_toggleLeft',
		'fe_toggleRight',
		'fe_trash',
		'fe_trash2',
		'fe_trendingDown',
		'fe_trendingUp',
		'fe_triangle',
		'fe_truck',
		'fe_tv',
		'fe_twitter',
		'fe_type',
		'fe_umbrella',
		'fe_underline',
		'fe_unlock',
		'fe_upload',
		'fe_uploadCloud',
		'fe_user',
		'fe_userCheck',
		'fe_userMinus',
		'fe_userPlus',
		'fe_userX',
		'fe_users',
		'fe_video',
		'fe_videoOff',
		'fe_voicemail',
		'fe_volume',
		'fe_volume1',
		'fe_volume2',
		'fe_volumeX',
		'fe_watch',
		'fe_wifi',
		'fe_wifiOff',
		'fe_wind',
		'fe_x',
		'fe_xCircle',
		'fe_xSquare',
		'fe_youtube',
		'fe_zap',
		'fe_zapOff',
		'fe_zoomIn',
		'fe_zoomOut',
	],
	'Solid Icons': [
		'ic_alignBottom',
		'ic_alignCenter',
		'ic_alignTop',
		'ic_alt',
		'ic_aperture',
		'ic_ascending',
		'ic_audio',
		'ic_badge',
		'ic_ban',
		'ic_basket',
		'ic_beaker',
		'ic_bell',
		'ic_bluetooth',
		'ic_bold',
		'ic_bolt',
		'ic_book',
		'ic_bookmark',
		'ic_both',
		'ic_bottom',
		'ic_box',
		'ic_boxed',
		'ic_briefcase',
		'ic_broken',
		'ic_browser',
		'ic_brush',
		'ic_bug',
		'ic_bullhorn',
		'ic_calculator',
		'ic_calendar',
		'ic_card',
		'ic_cart',
		'ic_center',
		'ic_chart',
		'ic_chat',
		'ic_check',
		'ic_circle',
		'ic_circleBottom',
		'ic_circleLeft',
		'ic_circleRight',
		'ic_circleTop',
		'ic_circular',
		'ic_clipboard',
		'ic_clock',
		'ic_closed',
		'ic_cloud',
		'ic_cloudy',
		'ic_code',
		'ic_cog',
		'ic_command',
		'ic_compass',
		'ic_contrast',
		'ic_copywriting',
		'ic_crop',
		'ic_cross',
		'ic_dashboard',
		'ic_deleteIconic',
		'ic_descending',
		'ic_dial',
		'ic_document',
		'ic_dollar',
		'ic_down',
		'ic_download',
		'ic_drive',
		'ic_droplet',
		'ic_eject',
		'ic_elevator',
		'ic_ellipses',
		'ic_empty',
		'ic_enter',
		'ic_euro',
		'ic_excerpt',
		'ic_exit',
		'ic_eye',
		'ic_eyedropper',
		'ic_file',
		'ic_fire',
		'ic_flag',
		'ic_flash',
		'ic_folder',
		'ic_fork',
		'ic_fourUp',
		'ic_full',
		'ic_glass',
		'ic_globe',
		'ic_graph',
		'ic_header',
		'ic_headphones',
		'ic_heart',
		'ic_height',
		'ic_high',
		'ic_home',
		'ic_image',
		'ic_inIconic',
		'ic_inbox',
		'ic_login',
		'ic_infinity',
		'ic_info',
		'ic_intact',
		'ic_italic',
		'ic_key',
		'ic_laptop',
		'ic_layers',
		'ic_left',
		'ic_lightbulb',
		'ic_link',
		'ic_list',
		'ic_location',
		'ic_locked',
		'ic_login',
		'ic_logout',
		'ic_loop',
		'ic_low',
		'ic_map',
		'ic_mark',
		'ic_marker',
		'ic_menu',
		'ic_microphone',
		'ic_minus',
		'ic_monitor',
		'ic_moon',
		'ic_move',
		'ic_note',
		'ic_off',
		'ic_open',
		'ic_out',
		'ic_paperclip',
		'ic_pause',
		'ic_pencil',
		'ic_people',
		'ic_person',
		'ic_phone',
		'ic_piece',
		'ic_pin',
		'ic_play',
		'ic_plus',
		'ic_pound',
		'ic_print',
		'ic_project',
		'ic_pulse',
		'ic_quoteSansLeft',
		'ic_quoteSansRight',
		'ic_quoteSerifLeft',
		'ic_quoteSerifRight',
		'ic_rain',
		'ic_random',
		'ic_record',
		'ic_redo',
		'ic_reload',
		'ic_rich',
		'ic_right',
		'ic_rss',
		'ic_script',
		'ic_share',
		'ic_shield',
		'ic_signal',
		'ic_signpost',
		'ic_skipBackward',
		'ic_skipForward',
		'ic_slr',
		'ic_spectrum',
		'ic_spreadsheet',
		'ic_square',
		'ic_standby',
		'ic_star',
		'ic_stepBackward',
		'ic_stepForward',
		'ic_stop',
		'ic_sun',
		'ic_tablet',
		'ic_tag',
		'ic_tags',
		'ic_target',
		'ic_task',
		'ic_terminal',
		'ic_text',
		'ic_thickBottom',
		'ic_thickLeft',
		'ic_thickRight',
		'ic_thickTop',
		'ic_threeUp',
		'ic_timer',
		'ic_top',
		'ic_transfer',
		'ic_transferDownload',
		'ic_transferUpload',
		'ic_trash',
		'ic_twoUp',
		'ic_underline',
		'ic_undo',
		'ic_unlocked',
		'ic_up',
		'ic_upload',
		'ic_video',
		'ic_warning',
		'ic_width',
		'ic_wifi',
		'ic_wrench',
		'ic_x',
		'ic_yen',
		'fa_fiveHundredPX',
		'fa_accessible-icon',
		'fa_accusoft',
		'fa_adn',
		'fa_adversal',
		'fa_affiliatetheme',
		'fa_algolia',
		'fa_amazon',
		'fa_amazon-pay',
		'fa_amilia',
		'fa_android',
		'fa_angellist',
		'fa_angrycreative',
		'fa_angular',
		'fa_app-store',
		'fa_app-store-ios',
		'fa_apper',
		'fa_apple',
		'fa_apple-pay',
		'fa_asymmetrik',
		'fa_audible',
		'fa_autoprefixer',
		'fa_avianex',
		'fa_aviato',
		'fa_aws',
		'fa_bandcamp',
		'fa_behance',
		'fa_behance-square',
		'fa_bimobject',
		'fa_bitbucket',
		'fa_bitcoin',
		'fa_bity',
		'fa_black-tie',
		'fa_blackberry',
		'fa_blogger',
		'fa_blogger-b',
		'fa_bluetooth',
		'fa_bluetooth-b',
		'fa_btc',
		'fa_buromobelexperte',
		'fa_buysellads',
		'fa_cc-amazon-pay',
		'fa_cc-amex',
		'fa_cc-apple-pay',
		'fa_cc-diners-club',
		'fa_cc-discover',
		'fa_cc-jcb',
		'fa_cc-mastercard',
		'fa_cc-paypal',
		'fa_cc-stripe',
		'fa_cc-visa',
		'fa_centercode',
		'fa_chrome',
		'fa_cloudscale',
		'fa_cloudsmith',
		'fa_cloudversify',
		'fa_codepen',
		'fa_codiepie',
		'fa_connectdevelop',
		'fa_contao',
		'fa_cpanel',
		'fa_creative-commons',
		'fa_creative-commons-by',
		'fa_creative-commons-nc',
		'fa_creative-commons-nc-eu',
		'fa_creative-commons-nc-jp',
		'fa_creative-commons-nd',
		'fa_creative-commons-pd',
		'fa_creative-commons-pd-alt',
		'fa_creative-commons-remix',
		'fa_creative-commons-sa',
		'fa_creative-commons-sampling',
		'fa_creative-commons-sampling-plus',
		'fa_creative-commons-share',
		'fa_css3',
		'fa_css3-alt',
		'fa_cuttlefish',
		'fa_d-and-d',
		'fa_dashcube',
		'fa_delicious',
		'fa_deploydog',
		'fa_deskpro',
		'fa_deviantart',
		'fa_digg',
		'fa_digital-ocean',
		'fa_discord',
		'fa_discourse',
		'fa_dochub',
		'fa_docker',
		'fa_draft2digital',
		'fa_dribbble',
		'fa_dribbble-square',
		'fa_dropbox',
		'fa_drupal',
		'fa_dyalog',
		'fa_earlybirds',
		'fa_ebay',
		'fa_edge',
		'fa_elementor',
		'fa_ello',
		'fa_ember',
		'fa_empire',
		'fa_envira',
		'fa_erlang',
		'fa_ethereum',
		'fa_etsy',
		'fa_expeditedssl',
		'fa_facebook',
		'fa_facebook-f',
		'fa_facebook-messenger',
		'fa_facebook-square',
		'fa_firefox',
		'fa_first-order',
		'fa_first-order-alt',
		'fa_firstdraft',
		'fa_flickr',
		'fa_flipboard',
		'fa_fly',
		'fa_font-awesome',
		'fa_font-awesome-alt',
		'fa_font-awesome-flag',
		'fa_font-awesome-logo-full',
		'fa_fort-awesome',
		'fa_fort-awesome-alt',
		'fa_forumbee',
		'fa_foursquare',
		'fa_free-code-camp',
		'fa_freebsd',
		'fa_fulcrum',
		'fa_galactic-republic',
		'fa_galactic-senate',
		'fa_get-pocket',
		'fa_gg',
		'fa_gg-circle',
		'fa_git',
		'fa_git-square',
		'fa_github',
		'fa_github-alt',
		'fa_github-square',
		'fa_gitkraken',
		'fa_gitlab',
		'fa_gitter',
		'fa_glide',
		'fa_glide-g',
		'fa_gofore',
		'fa_goodreads',
		'fa_goodreads-g',
		'fa_google',
		'fa_google-drive',
		'fa_google-play',
		'fa_google-plus',
		'fa_google-plus-g',
		'fa_google-plus-square',
		'fa_google-wallet',
		'fa_gratipay',
		'fa_grav',
		'fa_gripfire',
		'fa_grunt',
		'fa_gulp',
		'fa_hacker-news',
		'fa_hacker-news-square',
		'fa_hackerrank',
		'fa_hips',
		'fa_hire-a-helper',
		'fa_hooli',
		'fa_hornbill',
		'fa_hotjar',
		'fa_houzz',
		'fa_html5',
		'fa_hubspot',
		'fa_imdb',
		'fa_instagram',
		'fa_internet-explorer',
		'fa_ioxhost',
		'fa_itunes',
		'fa_itunes-note',
		'fa_java',
		'fa_jedi-order',
		'fa_jenkins',
		'fa_joget',
		'fa_joomla',
		'fa_js',
		'fa_js-square',
		'fa_jsfiddle',
		'fa_kaggle',
		'fa_keybase',
		'fa_keycdn',
		'fa_kickstarter',
		'fa_kickstarter-k',
		'fa_korvue',
		'fa_laravel',
		'fa_lastfm',
		'fa_lastfm-square',
		'fa_leanpub',
		'fa_less',
		'fa_line',
		'fa_linkedin',
		'fa_linkedin-in',
		'fa_linode',
		'fa_linux',
		'fa_lyft',
		'fa_magento',
		'fa_mailchimp',
		'fa_mandalorian',
		'fa_markdown',
		'fa_mastodon',
		'fa_maxcdn',
		'fa_medapps',
		'fa_medium',
		'fa_medium-m',
		'fa_medrt',
		'fa_meetup',
		'fa_megaport',
		'fa_microsoft',
		'fa_mix',
		'fa_mixcloud',
		'fa_mizuni',
		'fa_modx',
		'fa_monero',
		'fa_napster',
		'fa_neos',
		'fa_nimblr',
		'fa_nintendo-switch',
		'fa_node',
		'fa_node-js',
		'fa_npm',
		'fa_ns8',
		'fa_nutritionix',
		'fa_odnoklassniki',
		'fa_odnoklassniki-square',
		'fa_old-republic',
		'fa_opencart',
		'fa_openid',
		'fa_opera',
		'fa_optin-monster',
		'fa_osi',
		'fa_page4',
		'fa_pagelines',
		'fa_palfed',
		'fa_patreon',
		'fa_paypal',
		'fa_periscope',
		'fa_phabricator',
		'fa_phoenix-framework',
		'fa_phoenix-squadron',
		'fa_php',
		'fa_pied-piper',
		'fa_pied-piper-alt',
		'fa_pied-piper-hat',
		'fa_pied-piper-pp',
		'fa_pinterest',
		'fa_pinterest-p',
		'fa_pinterest-square',
		'fa_playstation',
		'fa_product-hunt',
		'fa_pushed',
		'fa_python',
		'fa_qq',
		'fa_quinscape',
		'fa_quora',
		'fa_r-project',
		'fa_ravelry',
		'fa_react',
		'fa_readme',
		'fa_rebel',
		'fa_red-river',
		'fa_reddit',
		'fa_reddit-alien',
		'fa_reddit-square',
		'fa_rendact',
		'fa_renren',
		'fa_replyd',
		'fa_researchgate',
		'fa_resolving',
		'fa_rev',
		'fa_rocketchat',
		'fa_rockrms',
		'fa_safari',
		'fa_sass',
		'fa_schlix',
		'fa_scribd',
		'fa_searchengin',
		'fa_sellcast',
		'fa_sellsy',
		'fa_servicestack',
		'fa_shirtsinbulk',
		'fa_shopware',
		'fa_simplybuilt',
		'fa_sistrix',
		'fa_sith',
		'fa_skyatlas',
		'fa_skype',
		'fa_slack',
		'fa_slack-hash',
		'fa_slideshare',
		'fa_snapchat',
		'fa_snapchat-ghost',
		'fa_snapchat-square',
		'fa_soundcloud',
		'fa_speakap',
		'fa_spotify',
		'fa_squarespace',
		'fa_stack-exchange',
		'fa_stack-overflow',
		'fa_staylinked',
		'fa_steam',
		'fa_steam-square',
		'fa_steam-symbol',
		'fa_sticker-mule',
		'fa_strava',
		'fa_stripe',
		'fa_stripe-s',
		'fa_studiovinari',
		'fa_stumbleupon',
		'fa_stumbleupon-circle',
		'fa_superpowers',
		'fa_supple',
		'fa_teamspeak',
		'fa_telegram',
		'fa_telegram-plane',
		'fa_tencent-weibo',
		'fa_themeco',
		'fa_themeisle',
		'fa_trade-federation',
		'fa_trello',
		'fa_tripadvisor',
		'fa_tumblr',
		'fa_tumblr-square',
		'fa_twitch',
		'fa_twitter',
		'fa_twitter-square',
		'fa_typo3',
		'fa_uber',
		'fa_uikit',
		'fa_uniregistry',
		'fa_untappd',
		'fa_usb',
		'fa_ussunnah',
		'fa_vaadin',
		'fa_viacoin',
		'fa_viadeo',
		'fa_viadeo-square',
		'fa_viber',
		'fa_vimeo',
		'fa_vimeo-square',
		'fa_vimeo-v',
		'fa_vine',
		'fa_vk',
		'fa_vnv',
		'fa_vuejs',
		'fa_weebly',
		'fa_weibo',
		'fa_weixin',
		'fa_whatsapp',
		'fa_whatsapp-square',
		'fa_whmcs',
		'fa_wikipedia-w',
		'fa_windows',
		'fa_wix',
		'fa_wolf-pack-battalion',
		'fa_wordpress',
		'fa_wordpress-simple',
		'fa_wpbeginner',
		'fa_wpexplorer',
		'fa_wpforms',
		'fa_xbox',
		'fa_xing',
		'fa_xing-square',
		'fa_y-combinator',
		'fa_yahoo',
		'fa_yandex',
		'fa_yandex-international',
		'fa_yelp',
		'fa_yoast',
		'fa_youtube',
		'fa_youtube-square',
		'fa_zhihu',
		'fas_address-book',
		'fas_address-card',
		'fas_adjust',
		'fas_air-freshener',
		'fas_align-center',
		'fas_align-justify',
		'fas_align-left',
		'fas_align-right',
		'fas_allergies',
		'fas_ambulance',
		'fas_american-sign-language-interpreting',
		'fas_anchor',
		'fas_angle-double-down',
		'fas_angle-double-left',
		'fas_angle-double-right',
		'fas_angle-double-up',
		'fas_angle-down',
		'fas_angle-left',
		'fas_angle-right',
		'fas_angle-up',
		'fas_angry',
		'fas_apple-alt',
		'fas_archive',
		'fas_archway',
		'fas_arrow-alt-circle-down',
		'fas_arrow-alt-circle-left',
		'fas_arrow-alt-circle-right',
		'fas_arrow-alt-circle-up',
		'fas_arrow-circle-down',
		'fas_arrow-circle-left',
		'fas_arrow-circle-right',
		'fas_arrow-circle-up',
		'fas_arrow-down',
		'fas_arrow-left',
		'fas_arrow-right',
		'fas_arrow-up',
		'fas_arrows-alt',
		'fas_arrows-alt-h',
		'fas_arrows-alt-v',
		'fas_assistive-listening-systems',
		'fas_asterisk',
		'fas_at',
		'fas_atlas',
		'fas_atom',
		'fas_audio-description',
		'fas_award',
		'fas_backspace',
		'fas_backward',
		'fas_balance-scale',
		'fas_ban',
		'fas_band-aid',
		'fas_barcode',
		'fas_bars',
		'fas_baseball-ball',
		'fas_basketball-ball',
		'fas_bath',
		'fas_battery-empty',
		'fas_battery-full',
		'fas_battery-half',
		'fas_battery-quarter',
		'fas_battery-three-quarters',
		'fas_bed',
		'fas_beer',
		'fas_bell',
		'fas_bell-slash',
		'fas_bezier-curve',
		'fas_bicycle',
		'fas_binoculars',
		'fas_birthday-cake',
		'fas_blender',
		'fas_blind',
		'fas_bold',
		'fas_bolt',
		'fas_bomb',
		'fas_bone',
		'fas_bong',
		'fas_book',
		'fas_book-open',
		'fas_book-reader',
		'fas_bookmark',
		'fas_bowling-ball',
		'fas_box',
		'fas_box-open',
		'fas_boxes',
		'fas_braille',
		'fas_brain',
		'fas_briefcase',
		'fas_briefcase-medical',
		'fas_broadcast-tower',
		'fas_broom',
		'fas_brush',
		'fas_bug',
		'fas_building',
		'fas_bullhorn',
		'fas_bullseye',
		'fas_burn',
		'fas_bus',
		'fas_bus-alt',
		'fas_calculator',
		'fas_calendar',
		'fas_calendar-alt',
		'fas_calendar-check',
		'fas_calendar-minus',
		'fas_calendar-plus',
		'fas_calendar-times',
		'fas_camera',
		'fas_camera-retro',
		'fas_cannabis',
		'fas_capsules',
		'fas_car',
		'fas_car-alt',
		'fas_car-battery',
		'fas_car-crash',
		'fas_car-side',
		'fas_caret-down',
		'fas_caret-left',
		'fas_caret-right',
		'fas_caret-square-down',
		'fas_caret-square-left',
		'fas_caret-square-right',
		'fas_caret-square-up',
		'fas_caret-up',
		'fas_cart-arrow-down',
		'fas_cart-plus',
		'fas_certificate',
		'fas_chalkboard',
		'fas_chalkboard-teacher',
		'fas_charging-station',
		'fas_chart-area',
		'fas_chart-bar',
		'fas_chart-line',
		'fas_chart-pie',
		'fas_check',
		'fas_check-circle',
		'fas_check-double',
		'fas_check-square',
		'fas_chess',
		'fas_chess-bishop',
		'fas_chess-board',
		'fas_chess-king',
		'fas_chess-knight',
		'fas_chess-pawn',
		'fas_chess-queen',
		'fas_chess-rook',
		'fas_chevron-circle-down',
		'fas_chevron-circle-left',
		'fas_chevron-circle-right',
		'fas_chevron-circle-up',
		'fas_chevron-down',
		'fas_chevron-left',
		'fas_chevron-right',
		'fas_chevron-up',
		'fas_child',
		'fas_church',
		'fas_circle',
		'fas_circle-notch',
		'fas_clipboard',
		'fas_clipboard-check',
		'fas_clipboard-list',
		'fas_clock',
		'fas_clone',
		'fas_closed-captioning',
		'fas_cloud',
		'fas_cloud-download-alt',
		'fas_cloud-upload-alt',
		'fas_cocktail',
		'fas_code',
		'fas_code-branch',
		'fas_coffee',
		'fas_cog',
		'fas_cogs',
		'fas_coins',
		'fas_columns',
		'fas_comment',
		'fas_comment-alt',
		'fas_comment-dots',
		'fas_comment-slash',
		'fas_comments',
		'fas_compact-disc',
		'fas_compass',
		'fas_compress',
		'fas_concierge-bell',
		'fas_cookie',
		'fas_cookie-bite',
		'fas_copy',
		'fas_copyright',
		'fas_couch',
		'fas_credit-card',
		'fas_crop',
		'fas_crop-alt',
		'fas_crosshairs',
		'fas_crow',
		'fas_crown',
		'fas_cube',
		'fas_cubes',
		'fas_cut',
		'fas_database',
		'fas_deaf',
		'fas_desktop',
		'fas_diagnoses',
		'fas_dice',
		'fas_dice-five',
		'fas_dice-four',
		'fas_dice-one',
		'fas_dice-six',
		'fas_dice-three',
		'fas_dice-two',
		'fas_digital-tachograph',
		'fas_directions',
		'fas_divide',
		'fas_dizzy',
		'fas_dna',
		'fas_dollar-sign',
		'fas_dolly',
		'fas_dolly-flatbed',
		'fas_donate',
		'fas_door-closed',
		'fas_door-open',
		'fas_dot-circle',
		'fas_dove',
		'fas_download',
		'fas_drafting-compass',
		'fas_draw-polygon',
		'fas_drum',
		'fas_drum-steelpan',
		'fas_dumbbell',
		'fas_edit',
		'fas_eject',
		'fas_ellipsis-h',
		'fas_ellipsis-v',
		'fas_envelope',
		'fas_envelope-open',
		'fas_envelope-square',
		'fas_equals',
		'fas_eraser',
		'fas_euro-sign',
		'fas_exchange-alt',
		'fas_exclamation',
		'fas_exclamation-circle',
		'fas_exclamation-triangle',
		'fas_expand',
		'fas_expand-arrows-alt',
		'fas_external-link-alt',
		'fas_external-link-square-alt',
		'fas_eye',
		'fas_eye-dropper',
		'fas_eye-slash',
		'fas_fast-backward',
		'fas_fast-forward',
		'fas_fax',
		'fas_feather',
		'fas_feather-alt',
		'fas_female',
		'fas_fighter-jet',
		'fas_file',
		'fas_file-alt',
		'fas_file-archive',
		'fas_file-audio',
		'fas_file-code',
		'fas_file-contract',
		'fas_file-download',
		'fas_file-excel',
		'fas_file-export',
		'fas_file-image',
		'fas_file-import',
		'fas_file-invoice',
		'fas_file-invoice-dollar',
		'fas_file-medical',
		'fas_file-medical-alt',
		'fas_file-pdf',
		'fas_file-powerpoint',
		'fas_file-prescription',
		'fas_file-signature',
		'fas_file-upload',
		'fas_file-video',
		'fas_file-word',
		'fas_fill',
		'fas_fill-drip',
		'fas_film',
		'fas_filter',
		'fas_fingerprint',
		'fas_fire',
		'fas_fire-extinguisher',
		'fas_first-aid',
		'fas_fish',
		'fas_flag',
		'fas_flag-checkered',
		'fas_flask',
		'fas_flushed',
		'fas_folder',
		'fas_folder-open',
		'fas_font',
		'fas_football-ball',
		'fas_forward',
		'fas_frog',
		'fas_frown',
		'fas_frown-open',
		'fas_futbol',
		'fas_gamepad',
		'fas_gas-pump',
		'fas_gavel',
		'fas_gem',
		'fas_genderless',
		'fas_gift',
		'fas_glass-martini',
		'fas_glass-martini-alt',
		'fas_glasses',
		'fas_globe',
		'fas_globe-africa',
		'fas_globe-americas',
		'fas_globe-asia',
		'fas_golf-ball',
		'fas_graduation-cap',
		'fas_greater-than',
		'fas_greater-than-equal',
		'fas_grimace',
		'fas_grin',
		'fas_grin-alt',
		'fas_grin-beam',
		'fas_grin-beam-sweat',
		'fas_grin-hearts',
		'fas_grin-squint',
		'fas_grin-squint-tears',
		'fas_grin-stars',
		'fas_grin-tears',
		'fas_grin-tongue',
		'fas_grin-tongue-squint',
		'fas_grin-tongue-wink',
		'fas_grin-wink',
		'fas_grip-horizontal',
		'fas_grip-vertical',
		'fas_h-square',
		'fas_hand-holding',
		'fas_hand-holding-heart',
		'fas_hand-holding-usd',
		'fas_hand-lizard',
		'fas_hand-paper',
		'fas_hand-peace',
		'fas_hand-point-down',
		'fas_hand-point-left',
		'fas_hand-point-right',
		'fas_hand-point-up',
		'fas_hand-pointer',
		'fas_hand-rock',
		'fas_hand-scissors',
		'fas_hand-spock',
		'fas_hands',
		'fas_hands-helping',
		'fas_handshake',
		'fas_hashtag',
		'fas_hdd',
		'fas_heading',
		'fas_headphones',
		'fas_headphones-alt',
		'fas_headset',
		'fas_heart',
		'fas_heartbeat',
		'fas_helicopter',
		'fas_highlighter',
		'fas_history',
		'fas_hockey-puck',
		'fas_home',
		'fas_hospital',
		'fas_hospital-alt',
		'fas_hospital-symbol',
		'fas_hot-tub',
		'fas_hotel',
		'fas_hourglass',
		'fas_hourglass-end',
		'fas_hourglass-half',
		'fas_hourglass-start',
		'fas_i-cursor',
		'fas_id-badge',
		'fas_id-card',
		'fas_id-card-alt',
		'fas_image',
		'fas_images',
		'fas_inbox',
		'fas_indent',
		'fas_industry',
		'fas_infinity',
		'fas_info',
		'fas_info-circle',
		'fas_italic',
		'fas_joint',
		'fas_key',
		'fas_keyboard',
		'fas_kiss',
		'fas_kiss-beam',
		'fas_kiss-wink-heart',
		'fas_kiwi-bird',
		'fas_language',
		'fas_laptop',
		'fas_laptop-code',
		'fas_laugh',
		'fas_laugh-beam',
		'fas_laugh-squint',
		'fas_laugh-wink',
		'fas_layer-group',
		'fas_leaf',
		'fas_lemon',
		'fas_less-than',
		'fas_less-than-equal',
		'fas_level-down-alt',
		'fas_level-up-alt',
		'fas_life-ring',
		'fas_lightbulb',
		'fas_link',
		'fas_lira-sign',
		'fas_list',
		'fas_list-alt',
		'fas_list-ol',
		'fas_list-ul',
		'fas_location-arrow',
		'fas_lock',
		'fas_lock-open',
		'fas_long-arrow-alt-down',
		'fas_long-arrow-alt-left',
		'fas_long-arrow-alt-right',
		'fas_long-arrow-alt-up',
		'fas_low-vision',
		'fas_luggage-cart',
		'fas_magic',
		'fas_magnet',
		'fas_male',
		'fas_map',
		'fas_map-marked',
		'fas_map-marked-alt',
		'fas_map-marker',
		'fas_map-marker-alt',
		'fas_map-pin',
		'fas_map-signs',
		'fas_marker',
		'fas_mars',
		'fas_mars-double',
		'fas_mars-stroke',
		'fas_mars-stroke-h',
		'fas_mars-stroke-v',
		'fas_medal',
		'fas_medkit',
		'fas_meh',
		'fas_meh-blank',
		'fas_meh-rolling-eyes',
		'fas_memory',
		'fas_mercury',
		'fas_microchip',
		'fas_microphone',
		'fas_microphone-alt',
		'fas_microphone-alt-slash',
		'fas_microphone-slash',
		'fas_microscope',
		'fas_minus',
		'fas_minus-circle',
		'fas_minus-square',
		'fas_mobile',
		'fas_mobile-alt',
		'fas_money-bill',
		'fas_money-bill-alt',
		'fas_money-bill-wave',
		'fas_money-bill-wave-alt',
		'fas_money-check',
		'fas_money-check-alt',
		'fas_monument',
		'fas_moon',
		'fas_mortar-pestle',
		'fas_motorcycle',
		'fas_mouse-pointer',
		'fas_music',
		'fas_neuter',
		'fas_newspaper',
		'fas_not-equal',
		'fas_notes-medical',
		'fas_object-group',
		'fas_object-ungroup',
		'fas_oil-can',
		'fas_outdent',
		'fas_paint-brush',
		'fas_paint-roller',
		'fas_palette',
		'fas_pallet',
		'fas_paper-plane',
		'fas_paperclip',
		'fas_parachute-box',
		'fas_paragraph',
		'fas_parking',
		'fas_passport',
		'fas_paste',
		'fas_pause',
		'fas_pause-circle',
		'fas_paw',
		'fas_pen',
		'fas_pen-alt',
		'fas_pen-fancy',
		'fas_pen-nib',
		'fas_pen-square',
		'fas_pencil-alt',
		'fas_pencil-ruler',
		'fas_people-carry',
		'fas_percent',
		'fas_percentage',
		'fas_phone',
		'fas_phone-slash',
		'fas_phone-square',
		'fas_phone-volume',
		'fas_piggy-bank',
		'fas_pills',
		'fas_plane',
		'fas_plane-arrival',
		'fas_plane-departure',
		'fas_play',
		'fas_play-circle',
		'fas_plug',
		'fas_plus',
		'fas_plus-circle',
		'fas_plus-square',
		'fas_podcast',
		'fas_poo',
		'fas_poop',
		'fas_portrait',
		'fas_pound-sign',
		'fas_power-off',
		'fas_prescription',
		'fas_prescription-bottle',
		'fas_prescription-bottle-alt',
		'fas_print',
		'fas_procedures',
		'fas_project-diagram',
		'fas_puzzle-piece',
		'fas_qrcode',
		'fas_question',
		'fas_question-circle',
		'fas_quidditch',
		'fas_quote-left',
		'fas_quote-right',
		'fas_random',
		'fas_receipt',
		'fas_recycle',
		'fas_redo',
		'fas_redo-alt',
		'fas_registered',
		'fas_reply',
		'fas_reply-all',
		'fas_retweet',
		'fas_ribbon',
		'fas_road',
		'fas_robot',
		'fas_rocket',
		'fas_route',
		'fas_rss',
		'fas_rss-square',
		'fas_ruble-sign',
		'fas_ruler',
		'fas_ruler-combined',
		'fas_ruler-horizontal',
		'fas_ruler-vertical',
		'fas_rupee-sign',
		'fas_sad-cry',
		'fas_sad-tear',
		'fas_save',
		'fas_school',
		'fas_screwdriver',
		'fas_search',
		'fas_search-minus',
		'fas_search-plus',
		'fas_seedling',
		'fas_server',
		'fas_shapes',
		'fas_share',
		'fas_share-alt',
		'fas_share-alt-square',
		'fas_share-square',
		'fas_shekel-sign',
		'fas_shield-alt',
		'fas_ship',
		'fas_shipping-fast',
		'fas_shoe-prints',
		'fas_shopping-bag',
		'fas_shopping-basket',
		'fas_shopping-cart',
		'fas_shower',
		'fas_shuttle-van',
		'fas_sign',
		'fas_sign-in-alt',
		'fas_sign-language',
		'fas_sign-out-alt',
		'fas_signal',
		'fas_signature',
		'fas_sitemap',
		'fas_skull',
		'fas_sliders-h',
		'fas_smile',
		'fas_smile-beam',
		'fas_smile-wink',
		'fas_smoking',
		'fas_smoking-ban',
		'fas_snowflake',
		'fas_solar-panel',
		'fas_sort',
		'fas_sort-alpha-down',
		'fas_sort-alpha-up',
		'fas_sort-amount-down',
		'fas_sort-amount-up',
		'fas_sort-down',
		'fas_sort-numeric-down',
		'fas_sort-numeric-up',
		'fas_sort-up',
		'fas_spa',
		'fas_space-shuttle',
		'fas_spinner',
		'fas_splotch',
		'fas_spray-can',
		'fas_square',
		'fas_square-full',
		'fas_stamp',
		'fas_star',
		'fas_star-half',
		'fas_star-half-alt',
		'fas_star-of-life',
		'fas_step-backward',
		'fas_step-forward',
		'fas_stethoscope',
		'fas_sticky-note',
		'fas_stop',
		'fas_stop-circle',
		'fas_stopwatch',
		'fas_store',
		'fas_store-alt',
		'fas_stream',
		'fas_street-view',
		'fas_strikethrough',
		'fas_stroopwafel',
		'fas_subscript',
		'fas_subway',
		'fas_suitcase',
		'fas_suitcase-rolling',
		'fas_sun',
		'fas_superscript',
		'fas_surprise',
		'fas_swatchbook',
		'fas_swimmer',
		'fas_swimming-pool',
		'fas_sync',
		'fas_sync-alt',
		'fas_syringe',
		'fas_table',
		'fas_table-tennis',
		'fas_tablet',
		'fas_tablet-alt',
		'fas_tablets',
		'fas_tachometer-alt',
		'fas_tag',
		'fas_tags',
		'fas_tape',
		'fas_tasks',
		'fas_taxi',
		'fas_teeth',
		'fas_teeth-open',
		'fas_terminal',
		'fas_text-height',
		'fas_text-width',
		'fas_th',
		'fas_th-large',
		'fas_th-list',
		'fas_theater-masks',
		'fas_thermometer',
		'fas_thermometer-empty',
		'fas_thermometer-full',
		'fas_thermometer-half',
		'fas_thermometer-quarter',
		'fas_thermometer-three-quarters',
		'fas_thumbs-down',
		'fas_thumbs-up',
		'fas_thumbtack',
		'fas_ticket-alt',
		'fas_times',
		'fas_times-circle',
		'fas_tint',
		'fas_tint-slash',
		'fas_tired',
		'fas_toggle-off',
		'fas_toggle-on',
		'fas_toolbox',
		'fas_tooth',
		'fas_trademark',
		'fas_traffic-light',
		'fas_train',
		'fas_transgender',
		'fas_transgender-alt',
		'fas_trash',
		'fas_trash-alt',
		'fas_tree',
		'fas_trophy',
		'fas_truck',
		'fas_truck-loading',
		'fas_truck-monster',
		'fas_truck-moving',
		'fas_truck-pickup',
		'fas_tshirt',
		'fas_tty',
		'fas_tv',
		'fas_umbrella',
		'fas_umbrella-beach',
		'fas_underline',
		'fas_undo',
		'fas_undo-alt',
		'fas_universal-access',
		'fas_university',
		'fas_unlink',
		'fas_unlock',
		'fas_unlock-alt',
		'fas_upload',
		'fas_user',
		'fas_user-alt',
		'fas_user-alt-slash',
		'fas_user-astronaut',
		'fas_user-check',
		'fas_user-circle',
		'fas_user-clock',
		'fas_user-cog',
		'fas_user-edit',
		'fas_user-friends',
		'fas_user-graduate',
		'fas_user-lock',
		'fas_user-md',
		'fas_user-minus',
		'fas_user-ninja',
		'fas_user-plus',
		'fas_user-secret',
		'fas_user-shield',
		'fas_user-slash',
		'fas_user-tag',
		'fas_user-tie',
		'fas_user-times',
		'fas_users',
		'fas_users-cog',
		'fas_utensil-spoon',
		'fas_utensils',
		'fas_vector-square',
		'fas_venus',
		'fas_venus-double',
		'fas_venus-mars',
		'fas_vial',
		'fas_vials',
		'fas_video',
		'fas_video-slash',
		'fas_volleyball-ball',
		'fas_volume-down',
		'fas_volume-off',
		'fas_volume-up',
		'fas_walking',
		'fas_wallet',
		'fas_warehouse',
		'fas_weight',
		'fas_weight-hanging',
		'fas_wheelchair',
		'fas_wifi',
		'fas_window-close',
		'fas_window-maximize',
		'fas_window-minimize',
		'fas_window-restore',
		'fas_wine-glass',
		'fas_wine-glass-alt',
		'fas_won-sign',
		'fas_wrench',
		'fas_x-ray',
		'fas_yen-sign',
	],
};
export default IcoNames;
